import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { rememberArrival } from "./lib/arrival";

// Before the app changes the address: where this visit came from.
rememberArrival();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
